export default __webpack_public_path__ + "d6eeb8ca3267c2ca6db9f0f15ddfc76c.png";